// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.to-upper-text[data-v-37f772ba] input {\r\n  text-transform: uppercase !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
